import styled from "@emotion/styled"
import { DARK_BLUE_COLOR, LIGHT_GREY_COLOR, PX18, PX24 } from "theme/consts"

const Root = styled.div`
  padding: 40px;
  border: 1px solid ${LIGHT_GREY_COLOR};
  border-radius: 20px;
  background-color: white;
  display: flex;
  flex-direction: column;
  gap: 25px;
  text-align: center;
  max-width: 50%;
  align-items: center;
  box-sizing: border-box;
  margin: 60px;
  @media (max-width: 1248px) {
    max-width: 80%;
    padding: 20px;
  }
`

const ErrorTitle = styled.h2`
  font-size: ${PX24};
  font-weight: 900;
  color: ${DARK_BLUE_COLOR};
`

const ErrorMessage = styled.span`
  font-size: ${PX18};
  color: ${DARK_BLUE_COLOR};
  margin-bottom: 10px;
`
export const ErrorContainer = function ({
  title,
  message,
  button,
}: {
  title: React.ReactNode
  message: React.ReactNode
  button?: React.ReactNode
}) {
  return (
    <Root>
      <ErrorTitle>{title}</ErrorTitle>
      <ErrorMessage>{message}</ErrorMessage>
      {button ? button : null}
    </Root>
  )
}
